module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/download-5f57aed223fba72545b66b327b5f3b70.svg";